import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root {
  --page-x: 6vw;
}

@media (max-width: 430px) {
  :root {
    --page-x: 12px;
  }
}

html {
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  background: #101118;
}

body {
  margin: 0;
  width: 100%;
  min-height: 100%;
  color: white;
  font-family: Unbounded, sans-serif;
  color: rgba(255, 255, 255, 1);
  background: #101118;
  overflow-x: hidden;
  opacity: 1;
  visibility: visible;

  #root {
    min-height: 100vh;
    background: #101118;
    opacity: 1;
    visibility: visible;
  }


  .hidden {
    display: none;
  }
}
`;
